import React from 'react';

import Subnavigation from '@interness/web-core/src/components/structure/Subnavigation/Subnavigation';

const Subnav = (props) => {
  return <Subnavigation menu={props.menu} menuTitle={props.title}/>
};

export default Subnav;